import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { changeActiveEHRJobsTab } from "app/store/ehrJobs/slice/ehrSlice";
import { USER_ROLES } from "static/constants";

const useJobTabs = (role, tabStyles) => {
  const dispatch = useDispatch();
  const tabs = [
    {
      label: "EHR Jobs",
      value: "hl7jobs",
      style: tabStyles(
        "hl7jobs",
        [USER_ROLES.ADMIN, USER_ROLES.CLINIC_ADMIN].includes(role)
      ),
    },
  ];
  const navigate = useNavigate();

  const onTabChange = (value) => {
    dispatch(changeActiveEHRJobsTab(value));
    navigate(`/ehr-jobs/${value}`);
  };

  return { tabs, onTabChange };
};

export default useJobTabs;
